<template>
  <div class="signInContent">
    <div class="closeBtn" @click="closePopup">X</div>
      <div v-if="userIsLoaded" style="text-align:left;">
          Logged in as {{userData.name}}<br>
          <div v-if="isTester && debug">
          {{userData}}
          </div>
          <form>
               <div class="form-group">
                 
                    <button :class="{active: false}" style="margin:auto;margin-bottom:80px"  @click.prevent="resetGame()">Reset Game</button>
                  <button :class="{active: false}" style="margin:auto;margin-bottom:80px;"  @click.prevent="signOut()">Sign Out</button>
                     </div>
        
         
                
         </form>
          <div class="playBtn" style="display:relative; margin:auto; bottom:20px; "  @click.prevent="closePopup">Continue</div>
  
          
         
      </div>
      <div v-else>
      <h2 v-if="signUp">Sign Up</h2>
      <h2 v-else>Sign In</h2>
      <form>
          <div v-if="signUp" class="form-group">
          <label for="displayName">Name</label>
          <input type="text" v-model="displayName" />
        </div>
        <div class="form-group">
          <label for="email">Email</label>
          <input type="text" v-model="email" />
          <span v-if="email.length > 1">{{ email_msg }}</span>
        </div>
        <div class="form-group">
          <label for="psw1">Password <span v-if="signUp" id="characters">(6 or more characters required)</span></label>
          <input type="password" v-model="password1" />
          <span v-show="msg1">{{ pwd1_msg }}</span>
        </div>
        <div v-if="signUp" class="form-group">
          <label for="psw2">Repeat Password</label>
          <input type="password" v-model="password2" />
          <span v-show="msg2">{{ pwd2_msg }}</span>
        </div>
         <div v-if="email.length > 1 && email_msg==''" @click.prevent="forgot()" style="font-size:12px;">Forgot your Password? <button class="smallButton">Reset Password </button><br><br></div>
       
        <div v-if="signUp" @click="signUp=!signUp" class="txtBtn">Have an account? Sign In</div>
        <div v-else @click="signUp=!signUp" class="txtBtn">No account? Sign Up</div>
         <div class="form-group" >
          
          <button v-if="signUp" :class="{active: disable_btn}" style="margin:auto;" :disabled="disable_btn" @click.prevent="on_signup()">Sign Up</button>
          <button v-else :class="{active: false}" style="margin:auto;"  @click.prevent="on_signin()">Sign In</button>
         
        </div>
      </form>
      </div>
      </div>
</template>
<script>

export default {
 
  data() {
    return {
      signUp:false,
      displayName:'',
      email: '',
      email_msg: '',
      password1: '',
      pwd1_msg: '',
      password2: '',
      pwd2_msg: '',
      disable_btn: true,
      msg1: true,
      msg2: true
    }
  },
  computed:{
    isTester(){
				return this.$store.getters.getIsTester
      },
      debug(){
				return this.$store.getters.getDebug
      },
      userIsLoaded(){
        return this.$store.getters.getUserIsLoaded
      },
      userData(){
           return this.$store.getters.getUserData
       
      
    },
  },
  // WATCH
  watch: {
    email: function(value) {
      this.valid_email(value, 'email_msg');
    },
    password1: function(value) {
      if(this.check_password_length(value, 'pwd1_msg', 6)) {
        this.check_passwords_match();
      }
    },
    password2: function(value) {
      if(this.check_password_length(value, 'pwd2_msg', 6)) {
        this.check_passwords_match();
      }
    }
  },
  
  // METHODS
  methods: {
    forgot(){
      console.log("FORGOT")
       //this.$store.dispatch('forgotPassword',this.email)
        this.$store.dispatch("showBasicHelp","An email has been sent to "+this.email+" please click on the link to reset your password.")
    },
    resetGame(){
      this.$store.dispatch('clearGame')
      this.$router.push({path:"game"})
      gsap.delayedCall(1,function(){location.reload()})
      // location.reload()
    },
    closePopup(){
      this.$store.commit('setShowSignIn',false)
    },
    valid_email(email, msg) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        this[msg] = '';
        return true;
      } else {
        this[msg] = 'Keep typing...waiting for a valid email';
        return false;
      } 
    },
    
    check_password_length(value, msg, total) {
      var length = value.length;
      var sum = 0;
      var display;
      
      sum = (total - length);
      
      switch(sum) {
        case 0:
          display = '';
          break;
        case 1:
          display = 'Keep going - just need '+ sum + ' more character.';
          break;
        default:
          display = 'Keep going - just need '+ sum + ' more characters';
      }
      
      if(length >= total) {
        this[msg] = '';
        return true;
      } else {
        this[msg] = display;
        return false;
      }
      
    },
    
    check_passwords_match() {
      if(this.password1.length > 5 && this.password2.length > 5) {
          if(this.password2 != this.password1) {
            this.pwd2_msg = 'Passwords do not match';
            this.disable_btn = true;
            return true;
          } else {
            this.pwd2_msg = '';
            this.disable_btn = false;
            return false;
          }
        }
    },
    
    on_signup() {
      this.$store.dispatch('signUserUp', {email: this.email, password: this.password1, displayName: this.displayName})
      
      this.displayName = ''
      this.email = ''
      this.password1 = ''
      this.password2 = ''
      this.email_msg = ''
      this.pwd1_msg = ''
      this.pwd2_msg = ''
      this.msg1 = false
      this.msg2 = false
      this.disable_btn = true
      
      //this.$emit('change_comp', 'results');
    }, 
    on_signin() {
        console.log("SIGN IN")
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password1})
      
      this.displayName = ''
      this.email = ''
      this.password1 = ''
      this.password2 = ''
      this.email_msg = ''
      this.pwd1_msg = ''
      this.pwd2_msg = ''
      this.msg1 = false
      this.msg2 = false
      this.disable_btn = true
      
      //this.$emit('change_comp', 'results');
    }, 
    signOut(){
      this.$router.push({ path: '/' })
      this.$store.dispatch("signUserOut")
    },
    show_terms() {
     // this.$emit('change_comp', 'terms');
    }
  }
  
}
 



</script>

<style lang="scss">


$green-dark: #79CB0A;
$green-light: #B5D020;
$orange-dark: #FF7700;
$orange-light: #FFB100;
$red:  #0ff;
$grey: #ffffff;

.playBtn{
		border:#fff solid 1px;
		border-radius:5px;
		padding:5px;
		width:150px;
		text-align: center;
		font-size:20px;
		color:#fff;
		position:absolute;
		left:0px;
		right:0px;
		cursor:pointer;
		bottom:100px;
		margin:auto;
	}




.signInContent{
    padding:10px;
    max-width:80%;
    min-width: 600px;
    position: relative;
    color:#ffffff;
    margin: auto;
    background-color: #000000cc;
}





form {
  width: 80%;
  height: 80%;
  padding: 10px 10% 20px 10%;
  color: #ffffff;;
  color: $grey;
}
form .form-group {
  display: flex;
  flex-direction: column;
  margin: 0 0 20px 0;
  color: $grey;
  font-size: .9em;
  
  label {
    margin: 0 0 16px 0;
    text-align: left;
  }
  
  span {
    font-size: .8em;
    color: $red;
  }
  
  span#characters {
    font-size: .8em;
    color: $grey;
  }
}
.form-group input[type="text"], 
.form-group input[type="password"] {
  border: none;
  outline: none;
  background: transparent;
  padding: 0 0 10px 0;
  font-size: 1em;
  color:#0ff;
  border-bottom: 1px dotted $grey;
}
.form-group input[type="password"] {
  color: $red;
}
form .form-group:last-child {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 40px 0 0 0;
  
  button {
    border: none;
    background: linear-gradient(to left, $orange-dark , $orange-light);
    padding: 10px 30px;
    border-radius: 20px;
    color: #FFFFFF;
    font-size: .9em;
    font-weight: bold;
    letter-spacing: 1px;
    cursor: pointer;
  }
    button:hover {
      transform:scale(1.02);
    }
  button.active {
    opacity: .5;
    cursor: default;
  }
  
 
}
.txtBtn{
  cursor:pointer;
}
.txtBtn:hover{
  transform:scale(1.02);
}
.smallButton {
    border: none;
    background: linear-gradient(to left, $orange-dark , $orange-light);
    padding: 5px 10px;
    border-radius: 10px;
    color: #FFFFFF;
    margin-left:10px;
    font-weight: bold;
    letter-spacing: 1px;
    cursor: pointer;
  }
  .smallButton:hover {
    transform:scale(1.02);
  }
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
}
input:-webkit-autofill {
    -webkit-text-fill-color: white !important;

}
.fade-enter-active, .fade-leave-active {
  transition: all .8s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
  transform: translateX(-40px);
}
</style>
